Promise.prototype._loading = function (loading = () => {}) {
    loading()
    return Promise.prototype.finally.apply(this, [() => {
        loading()
    }]);
}